// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import SaintPierreAndMiquelon from '../_raw/flag/icon_flag_saint_pierre_and_miquelon.png';

export default () => <img src={SaintPierreAndMiquelon} alt="SaintPierreAndMiquelon" />;
